import { Node, Component } from 'rete'
import {
  NodeData,
  WorkerInputs,
  WorkerOutputs,
} from 'rete/types/core/data'
import Vue from 'vue'
import i18n from 'vue-i18n'

import { BaseNodeModel } from './BaseNode/BaseNodeModel'
import {
  BaseNodeStruct,
  CustomNode
} from './index'

export default abstract class CustomNodeComponent extends Component {
  declare sidebarComponent: typeof Vue | null

  data: {
    render: 'vue',
    props: { i18n : i18n },
    component: typeof Vue
  }

  nodeBuilder: typeof CustomNode
  nodeProps?: { [key: string]: unknown }

  protected constructor(component: typeof Vue, builder: typeof CustomNode, name: string, i18n: i18n, nodeProps?: { [key: string]: unknown }) {
    super(name)
    this.nodeBuilder = builder

    this.data = {
      render: 'vue',
      props: { i18n },
      component: component,
    }

    if (nodeProps) {
      this.nodeProps = nodeProps
    }
  }

  builder(node: Node): Promise<void> {
    return new Promise(resolve => resolve())
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  worker(node: NodeData, inputs: WorkerInputs, outputs: WorkerOutputs, ...args: any[]) {
  }

  abstract getBaseNodeModel: ([ x, y ]: [number, number]) => BaseNodeModel

  build(node: CustomNode): Promise<CustomNode> {
    return super.build(node) as Promise<CustomNode>
  }

  async createNode(struct: BaseNodeStruct): Promise<CustomNode> {
    return await this.build(new this.nodeBuilder(this.name, struct, ...this.nodeProps ? [ this.nodeProps ] : []))
  }

  async createNewNode(position: [ number, number ]): Promise<CustomNode> {
    return await this.build(new this.nodeBuilder(this.name, this.getBaseNodeModel(position), this.nodeProps ?? undefined))
  }
}
